import userService from "@/services/users.service"

const initialState = { 
    users: [],
    selectedUser: null,
    customers: [],
    calls: [],
    newCalls: [],
    completedCalls: [],
    dashboardData: null
};

export const users = {
    namespaced: true,
    state: initialState,
    actions: {
        // ✅ USER AKTIONEN
        async addUsers({ commit }, user) {
            const newUser = await userService.addUsers(user);
            commit('addUserSuccess', newUser);
            return newUser;
        },

        async getUsers({ commit }) {
            const users = await userService.getUsers();
            commit('getUsersSuccess', users);
            return users;
        },

        async getUserById({ commit }, userId) {
            const user = await userService.getUserById(userId);
            commit('getUserSuccess', user);
            return user;
        },

        async updateUser({ commit }, { data, user }) {
            const updatedUser = await userService.updateUser(data, user);
            commit('updateUserSuccess', updatedUser);
            return updatedUser;
        },

        async deleteUser({ commit }, userId) {
            await userService.deleteUser(userId);
            commit('deleteUserSuccess', userId);
        },

        async enableUser({ commit }, userId) {
            const result = await userService.enableUser(userId);
            commit('enableUserSuccess', userId);
            return result;
        },

        // ✅ CUSTOMER AKTIONEN
        async getCustomers({ commit }) {
            const customers = await userService.getCustomers();
            commit('getCustomersSuccess', customers);
            return customers;
        },

        async updateCustomer({ commit }, customer) {
            const updatedCustomer = await userService.updateCustomer(customer);
            commit('updateCustomerSuccess', updatedCustomer);
            return updatedCustomer;
        },

        async deleteCustomer({ commit }, customerId) {
            await userService.deleteCustomer(customerId);
            commit('deleteCustomerSuccess', customerId);
        },

        // ✅ CALL-MANAGEMENT AKTIONEN
        async getCalls({ commit }) {
            const calls = await userService.getCalls();
            commit('getCallsSuccess', calls);
            return calls;
        },

        async deleteCall({ commit }, callId) {
            await userService.deleteCall(callId);
            commit('deleteCallSuccess', callId);
        },

        async getCallsById({ commit }) {
            const calls = await userService.getCallsById();
            commit('getCallsByIdSuccess', calls);
            return calls;
        },

        async updateCallStatus({ commit }, calls) {
            const result = await userService.updateCallStatus(calls);
            commit('updateCallStatusSuccess', calls);
            return result;
        },

        async updateBulkStatus({ commit }, calls) {
            const result = await userService.updateBulkStatus(calls);
            commit('updateBulkStatusSuccess', calls);
            return result;
        },

        async getNewCalls({ commit }) {
            const newCalls = await userService.getNewCalls();
            commit('getNewCallsSuccess', newCalls);
            return newCalls;
        },

        async getcompletedCalls({ commit }) {
            const completedCalls = await userService.getcompletedCalls();
            commit('getCompletedCallsSuccess', completedCalls);
            return completedCalls;
        },

        // ✅ WEITERE AKTIONEN
        async fetchRole() {
            return await userService.fetchRole();
        },

        async updatePassword({ commit }, user) {
            const updateduser = await userService.updatePassword(user);
            commit('updateUserSuccess', updateduser);
            return updateduser;
        },

        async getUserCount({ commit }) {
            const dashboardData = await userService.getUserCount();
            commit('getDashboardDataSuccess', dashboardData);
            return dashboardData;
        },

        async fetchCallsCount(month) {
            return await userService.fetchCallsCount(month);
        }
    },
    
    mutations: {
        // ✅ USER MUTATIONEN
        addUserSuccess(state, user) {
            state.users.push(user);
        },
        
        getUsersSuccess(state, users) {
            state.users = users;
        },
        
        getUserSuccess(state, user) {
            state.selectedUser = user;
        },
        
        updateUserSuccess(state, updatedUser) {
            const index = state.users.findIndex(user => user.id === updatedUser.id);
            if (index !== -1) {
                state.users.splice(index, 1, updatedUser);
            }
            state.selectedUser = updatedUser;
        },
        
        deleteUserSuccess(state, userId) {
            state.users = state.users.filter(user => user.id !== userId);
        },

        enableUserSuccess(state, userId) {
            const user = state.users.find(u => u.id === userId);
            if (user) {
                user.enabled = true;
            }
        },

        // ✅ CUSTOMER MUTATIONEN
        getCustomersSuccess(state, customers) {
            state.customers = customers;
        },
        
        updateCustomerSuccess(state, updatedCustomer) {
            const index = state.customers.findIndex(customer => customer.id === updatedCustomer.id);
            if (index !== -1) {
                state.customers.splice(index, 1, updatedCustomer);
            }
        },
        
        deleteCustomerSuccess(state, customerId) {
            state.customers = state.customers.filter(customer => customer.id !== customerId);
        },

        // ✅ CALL MUTATIONEN
        getCallsSuccess(state, calls) {
            state.calls = calls;
        },

        deleteCallSuccess(state, callId) {
            state.calls = state.calls.filter(call => call.id !== callId);
        },

        getCallsByIdSuccess(state, calls) {
            state.calls = calls;
        },

        updateCallStatusSuccess(state, updatedCall) {
            const index = state.calls.findIndex(call => call.id === updatedCall.id);
            if (index !== -1) {
                state.calls.splice(index, 1, updatedCall);
            }
        },

        updateBulkStatusSuccess(state, calls) {
            // Update multiple calls
            calls.forEach(updatedCall => {
                const index = state.calls.findIndex(call => call.id === updatedCall.id);
                if (index !== -1) {
                    state.calls.splice(index, 1, updatedCall);
                }
            });
        },

        getNewCallsSuccess(state, newCalls) {
            state.newCalls = newCalls;
        },

        getCompletedCallsSuccess(state, completedCalls) {
            state.completedCalls = completedCalls;
        },

        // ✅ DASHBOARD MUTATIONEN
        getDashboardDataSuccess(state, dashboardData) {
            state.dashboardData = dashboardData;
        }
    },
    
    getters: {
        getUsers(state) {
            return state.users;
        },
        
        getSelectedUser(state) {
            return state.selectedUser;
        },

        getCustomers(state) {
            return state.customers;
        },

        getCalls(state) {
            return state.calls;
        },

        getNewCalls(state) {
            return state.newCalls;
        },

        getCompletedCalls(state) {
            return state.completedCalls;
        },

        getDashboardData(state) {
            return state.dashboardData;
        }
    }
}